import Vue from 'vue';
import App from '@/App.vue';
import '@/authInterceptor';
import '@/plugins/axios';
import vuetify from '@/plugins/vuetify';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

// handle page reloads
const app: Vue = new Vue({
  el: '#app',
  vuetify,
  router,
  store,
  components: {},
  render: h => h(App),
});
